export const TASKS_PERMISSION_CODES = {
  VIEW_DETAIL: 'TAREAS.VER_DETALLE',
  PUBLISH_COMMENT: 'TAREAS.PUBLICAR_COMENTARIO',
  ATTACH_FILE_TO_COMMENT: 'TAREAS.ADJUNTAR_ARCHIVO_A_COMENTARIO',
  GO_TO_ASSOCIATED_CASE: 'TAREAS.IR_AL_CASO_ASOCIADO',
  CHANGE_STATUS: 'TAREAS.CAMBIAR_ESTADO',
  EDIT_DOCUMENT: 'TAREAS.EDITAR_DOCUMENTO',
  REMOVE_ASSIGNED_PERSON: 'TAREAS.QUITAR_A_PERSONA_ASIGNADA',
  DOWNLOAD_EXCEL: 'TAREAS.DESCARGAR_EXCEL',
  CREATE_TASKS: 'TAREAS.CREAR_TAREAS',
  VIEW_SECTION: 'TAREAS.VER_SECCION',
  VIEW_DETAIL_TASKS: 'TAREAS.VER_DETALLE.VER_SECCION',
};
